export default __webpack_public_path__ + "static/media/tc6.258a590c.png";